<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="items"
    :indexNested="true"
    :maskFields="maskFields"
    :disablePagination="true"    
    :showExpand="true"
    :customExpandIcon="true"
    @row-clicked="handleRowClicked"
    class="row-pointer"
    :containSearchBar="false"
  >

    <template slot="new">
      <New
        @entry-created="entryCreated"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="show" slot-scope="{ item }">
      <Edit
        :entry="item"
        :readOnly="true"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="edit" slot-scope="{ item }">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
      />
    </template>

    <template slot="delete" slot-scope="{ item }">
      <Delete
        :entry="item"        
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template v-slot:expand="{ item, headers }">
      <td :colspan="headers.length" :class="'px-0 px-sm-2 px-md-6 mt-3 ' + ($vuetify.breakpoint.smAndDown ? 'v-data-table__mobile-row': '')">
        <BuildingLevelIndex
          v-if="true"
          :hasTopMenu="false"
          :hasTableTitle="false"
          :loading="false"
          :extraData="extraData"
          :items.sync="item.buildingLevelsAttributes"
          class="mt-6"
          :readOnly="readOnly"
        />
      </td>
    </template>

    <template v-slot:expandColumn="{ item, isExpanded, expand }">
      <v-btn text color="primary" v-if="!isExpanded">Ver níveis</v-btn>
      <v-btn text color="primary" v-if="isExpanded"><v-icon left>mdi-eye-off</v-icon>Níveis</v-btn>
    </template>

  </BaseIndex>
</template>

<script>
// import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import BuildingLevelIndex from "@models/storage_shelves/storage_buildings/building_levels/index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";

export default {
  data() {
    return {
      loading: false,
      pageLoading: false,
      totalItems: 0,
      tableHeaders: [
        //trocar id para code depois que vier a coluna
        // { text: "Código", align: "left", sortable: true, value: "code" },
        { text: "Nome", align: "left", sortable: true, value: "name" },        
        // { text: "Localização", align: "left", sortable: true, value: "location" },
        // { text: "Capacidade", align: "left", sortable: true, value: "capacity" },
        // { text: "Qtd. de Itens Disponíveis", align: "left", sortable: true, value: "storageItemsNumber" },
        { text: "Ações", align: "left", sortable: false, value: "action" }
      ],
      maskFields: [
        // { field: 'area', mask: 'number_unit', unit: 'm^2' },
        { field: 'capacity', mask: 'number_unit', unit: 'Kg' }, 
        // { field: 'storageItemsNumber', mask: 'number'}, 
      ],
      infoHeaders: [],
      options: { //objeto específico para configurar e armazenar as informações da paginação e ordenação.
        page: 1,
        itemsPerPage: 10,
        sortBy: ["name"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [], //array para armazenar os filtros inseridos pelo usuário
      typeOperators: [], //array que traz do banco os operadores que serão utilizados nos filtros
      serverFields: [], // array que traz do banco quais os campos que podem ser aplicados filtros
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Módulo/Edifício"
    },
    modelNamePlural: {
      type: String,
      default: "Módulos/Edifícios"
    },
    extraData: {},
    readOnly: {
      type: Boolean,
      default: false,
    },
    items: [],
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
    BuildingLevelIndex: BuildingLevelIndex,
  },
  created() {
    // this.loadServerEntries();
    console.log("building index", this.extraData);
  },
  methods: {
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;      
    },
    entryUpdated: function(){
      // this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(building){
      // this.loadServerEntries();
      console.log("building", building);
      this.items.push(building);
      console.log("items", this.items);
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){
      // this.loadServerEntries();
      // this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    optionsChange: function(opts) {
      this.options = opts;
      // this.loadServerEntries();
    },
    handleRowClicked: function(rowArguments) {
      console.log("row click", rowArguments);
      if (rowArguments && rowArguments[1]) {
        rowArguments[1].expand(!rowArguments[1].isExpanded);
      }
    }
  }
};

</script>

<style lang="css" scoped>
  .row-pointer >>> tbody tr :hover {
    cursor: pointer;
  }
</style>
